import { AbText } from "../../widgets/text/text.widget.js";
import { i18n } from "../../domain/i18n.js";

const formats = {
  en: 'MM-dd-yyyy',
  de: 'dd.MM.yyyy',
  fr: 'dd.MM.yyyy',
  es: 'dd.MM.yyyy',
  it: 'dd.MM.yyyy'
};

/**
 * @typedef {RenderableProps} _AbVerifiedDateBanner_Props
 * @property {_Company} company
 * @property {'md'|'lg'} size
 */
export function AbVerifiedDateBanner({ company, size, t0 }, { formatDate, language }) {
  return (
    <div className={`ab-verified-date-banner ab-size-${size}`}>
      <span className="ab-text-zone">
        {!t0 && <AbText text={i18n.contents.texts.lastVerified} emphasis="light" />}
        {(t0 === 'no-account' || t0 === 'not-approved') && <AbText text={i18n.contents.texts.lastVerified_t0NotApproved} emphasis="light" />}
        {(t0 === 'no-brands') && <AbText text={i18n.contents.texts.lastVerified_t0NoBrands} emphasis="light" />}
        <AbText text={': '} emphasis="light" />
        <AbText text={formatDate(company.lastVerifiedDate, formats[language] || formats.en)} emphasis={true} />
      </span>
      <span className={`ab-status-circle ${t0 ? 'ab-status-yellow' : 'ab-status-green'}`} />
    </div>
  );
}
